import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle, FaSchool, FaGlobe, FaBullseye } from "react-icons/fa";
import aboutImage from "../assets/images/aboutImage.avif"; // Add a relevant image path
import secondaryImage from "../assets/images/secondaryImage.avif"; // Add a second image path
import Navbar from "../components/Navbar"; // Import existing Navbar component

const About = () => {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-gray-100 min-h-screen pt-36" // Updated padding to ensure no overlap
    >
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <div className="relative bg-blue-100 py-16 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-blue-900 mb-6">About Joy Gardens School</h1>
          <p className="text-lg text-gray-700 leading-relaxed">
            Providing excellence in education for Pre-primary, Primary, and Junior Secondary learners in Nairobi, Kenya.
          </p>
        </div>
        <img
          src={aboutImage}
          alt="About Joy Gardens"
          className="absolute top-1/2 left-1/2 w-1/2 h-auto rounded-lg shadow-lg transform -translate-x-1/2 -translate-y-1/2 opacity-30"
        />
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-6 md:px-16 py-36">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Mission and Vision */}
          <div>
            <div className="flex items-center mb-8">
              <FaBullseye className="text-blue-900 text-5xl mr-4" />
              <h2 className="text-3xl font-semibold text-blue-900">Our Mission</h2>
            </div>
            <p className="text-gray-700 leading-relaxed mb-8">
              To nurture students into lifelong learners and responsible citizens through a holistic education that focuses on academic excellence, personal growth, and community impact.
            </p>
            <div className="flex items-center mb-8">
              <FaGlobe className="text-blue-900 text-5xl mr-4" />
              <h2 className="text-3xl font-semibold text-blue-900">Our Vision</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              To be the leading institution in Nairobi, Kenya, known for providing transformative education and fostering global leaders of tomorrow.
            </p>
          </div>

          {/* Core Values */}
          <div>
            <h2 className="text-3xl font-semibold text-blue-900 mb-6">Core Values</h2>
            <ul className="space-y-4">
              <li className="flex items-center">
                <FaCheckCircle className="text-yellow-500 text-3xl mr-4" />
                <span className="text-gray-700">Integrity and Respect</span>
              </li>
              <li className="flex items-center">
                <FaCheckCircle className="text-yellow-500 text-3xl mr-4" />
                <span className="text-gray-700">Excellence in Academics</span>
              </li>
              <li className="flex items-center">
                <FaCheckCircle className="text-yellow-500 text-3xl mr-4" />
                <span className="text-gray-700">Inclusivity and Diversity</span>
              </li>
              <li className="flex items-center">
                <FaCheckCircle className="text-yellow-500 text-3xl mr-4" />
                <span className="text-gray-700">Community Engagement</span>
              </li>
              <li className="flex items-center">
                <FaCheckCircle className="text-yellow-500 text-3xl mr-4" />
                <span className="text-gray-700">Innovation and Creativity</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Transparent Image Section */}
        <div className="relative mt-16">
          <img
            src={secondaryImage}
            alt="Additional Information"
            className="w-full h-auto rounded-lg shadow-lg opacity-80 hover:opacity-100 transition duration-500"
          />
          <div className="absolute inset-0 flex flex-col justify-center items-center bg-black bg-opacity-30 text-white text-center p-6">
            <h2 className="text-3xl font-bold mb-4">Transforming Education</h2>
            <p className="text-lg">
              At Joy Gardens, we are dedicated to creating a learning environment that fosters creativity, critical thinking, and a passion for knowledge.
            </p>
          </div>
        </div>

        {/* History Section */}
        <div className="mt-16">
          <h2 className="text-3xl font-semibold text-blue-900 mb-6">Our History</h2>
          <p className="text-gray-700 leading-relaxed">
            Established in 2010, Joy Gardens School has grown from a small institution to one of Nairobi's most trusted schools. Our dedicated team of highly qualified teachers ensures every student receives a personalized and engaging learning experience. With modern facilities and a commitment to excellence, we pride ourselves on shaping the future leaders of Kenya and beyond.
          </p>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <a
            href="/admissions"
            className="bg-yellow-500 text-blue-900 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:bg-yellow-600 transition"
          >
            Learn More About Admissions
          </a>
        </div>
      </div>
    </motion.section>
  );
};

export default About;